<router-outlet></router-outlet>

<app-modal></app-modal>
<app-toast></app-toast>
<app-base-modal></app-base-modal>
